import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { OfferSummaryDataService } from "../../../core/services/offer-summary-data.service";
import { ClearedOfferFileData, TableRow } from "./clearedOfferFile";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-offer-summary-confirmation-dialog",
  templateUrl: "./offer-summary-confirmation-dialog.component.html",
  styleUrls: ["./offer-summary-confirmation-dialog.component.css"],
})
export class OfferSummaryConfirmationDialogComponent
  implements OnInit, OnDestroy
{
  constructor(private offerSummaryDataService: OfferSummaryDataService) {}

  dataSubscription: Subscription;
  offerSummary: ClearedOfferFileData = {
    name: "",
    date_time: null,
    date_time_label: "",
    header: {
      resource: "",
      trading_date: "",
      hour: "",
      offered_volume: "",
      cleared_volume: "",
      percentage_cleared: "",
    },
    data: [],
    loaded: false,
    error: false,
    saved: false,
  };

  @Output() buttonEvent = new EventEmitter<string>();

  ngOnInit() {
    this.loadClearedOfferFileData();
  }

  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    // reset the ClearedOfferFileData object
    this.offerSummary = {
      name: "",
      date_time: null,
      date_time_label: "",
      header: {
        resource: "",
        trading_date: "",
        hour: "",
        offered_volume: "",
        cleared_volume: "",
        percentage_cleared: "",
      },
      data: [],
      loaded: false,
      error: false,
      saved: false,
    };
  }

  acceptClicked() {
    if (this.offerSummary.loaded && !this.offerSummary.error) {
      this.offerSummaryDataService.postFile(true); // resend the last file (which will be the current one displayed)
      this.buttonEvent.emit("Confirm");
    }
  }

  cancelClicked() {
    this.buttonEvent.emit("Cancel");
  }

  loadClearedOfferFileData() {
    if (!this.dataSubscription) {
      this.dataSubscription = this.offerSummaryDataService
        .getClearedOfferFileData()
        .subscribe((offerSummary) => {
          if (offerSummary) {
            this.offerSummary = offerSummary;
            if (this.offerSummary.error) {
              this.buttonEvent.emit("Cancel");
            }
            if (this.offerSummary.saved) {
              this.buttonEvent.emit("Confirm");
            } // when user clicks button it forces upload of file again, when this is confirmed then emit the button event so GUI continues only at the right time
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/offer-summary-confirmation-dialog/offer-summary-confirmation-dialog.component.ts